import { render, staticRenderFns } from "./IconSearchSolid.vue?vue&type=template&id=f1b6700e"
import script from "./IconSearchSolid.vue?vue&type=script&lang=js"
export * from "./IconSearchSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports